module.exports = __webpack_public_path__ + "static/media/template.1a0edcc1.csv";